import { MAX_CONNECTION_SIZE } from '@nudool/shared';

// The fewest round trips an export can make, tied to the server's own connection page cap.
export const EXPORT_PAGE_SIZE = MAX_CONNECTION_SIZE;
